import { banner, profile } from "../assets";
import HeroSection from "../components/HeroSection";

const ResearchPage = () => {
    // Research Publications and Articles
    const publications = [
        {
            id: 1,
            title: "Kundali Melapke Astakutanam Vaigyanikata",
            journal: "Sodh Prabha, Publication Department, S.L.S.R.S.V., New Delhi",
            year: "2011",
            type: "Research Article",
            description: "Scientific analysis of Ashtakuta system in horoscope matching.",
            category: "Jyotish",
            status: "Published"
        },
        {
            id: 2,
            title: "Matsya Purane Bhumiparikshyanam",
            journal: "Padma Parag, Sahitya Vibhag, Kashmir University, Srinagar",
            year: "2014-15",
            pages: "25-29",
            type: "Research Article",
            description: "Study of land examination principles in Matsya Purana.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 3,
            title: "Jyotish Shastre Vara Vadhu Melapak Vimarsha",
            journal: "HariPrabha, Haryana Sanskrit Academy, Panchkula",
            year: "2014",
            pages: "103-106",
            type: "Research Article",
            description: "Discourse on bride and groom compatibility in Jyotish Shastra.",
            category: "Jyotish",
            status: "Published"
        },
        {
            id: 4,
            title: "Grahanaam Rogkaarkatwe Jyotish Shastriyaah Pramukha Hetawah",
            journal: "Bhaishajya Jyotish Manjusha, S.L.S.R.S.V., New Delhi",
            year: "2014",
            pages: "09-14",
            type: "Research Article",
            description: "Principal causes of planetary influences on diseases in Jyotish Shastra.",
            category: "Medical Astrology",
            status: "Published"
        },
        {
            id: 5,
            title: "Vaidikjyotise Agnimaandyadyudarrogah",
            journal: "Bhaishajya Jyotish Manjusha, S.L.S.R.S.V., New Delhi",
            year: "2014",
            pages: "10-14",
            type: "Research Article",
            description: "Study of digestive disorders including acidity in Vedic Jyotish.",
            category: "Medical Astrology",
            status: "Published"
        },
        {
            id: 6,
            title: "Jyotish Shastra me Netra Rog Vichar",
            journal: "Bhaishajya Jyotish Manjusha, S.L.S.R.S.V., New Delhi",
            year: "2014",
            pages: "79-90",
            type: "Research Article",
            description: "Analysis of eye diseases in Jyotish Shastra.",
            category: "Medical Astrology",
            status: "Published"
        },
        {
            id: 7,
            title: "Bhavan Nirmaan Me Salya Niskasan",
            journal: "Visvajayanti, Visweswaranand Vaidik Shodh Sanststhan Sadhu Ashram, Hoshiarpur",
            year: "2015",
            pages: "37-39",
            type: "Research Article",
            description: "Removal of defects in building construction according to Vastu principles.",
            category: "Vastu Shastra",
            status: "Published"
        },
        {
            id: 8,
            title: "Jyotish Shastra Me Swasthya Chintan",
            journal: "Jyotirmayee Shodh Patrika, Uttarakhand Open University, Haldwani",
            year: "2011",
            type: "Research Article",
            description: "Health considerations in Jyotish Shastra.",
            category: "Medical Astrology",
            status: "Published"
        },
        {
            id: 9,
            title: "Ratnopateh Pouranika-avdharanayaah Vaigyanikatvam Jyotishiyam Mahatvam Cha",
            journal: "Abhyudayah Refereed Research Journal, Delhi",
            year: "2012",
            type: "Research Article",
            description: "Scientific validity and astrological significance of Puranic concepts of gemstones.",
            category: "Jyotish",
            status: "Published"
        },
        {
            id: 10,
            title: "Vaidik Jyotish Shastra Me Hridaya Rog Vichaar",
            journal: "Lok Sampark Vibhag, Solan, Govt. of Himachal Pradesh",
            year: "Not Available",
            type: "Research Article",
            description: "Analysis of heart diseases in Vedic Jyotish Shastra.",
            category: "Medical Astrology",
            status: "Published"
        },
        {
            id: 11,
            title: "Jyotish Ki Dristi Me-2013",
            journal: "Rupayan Magazine, Amar Ujjala, Delhi",
            year: "2012",
            type: "Magazine Article",
            description: "Astrological perspective on the year 2013.",
            category: "Jyotish",
            status: "Published"
        },
        {
            id: 12,
            title: "Devi Ke Nav Rupon Ke Nav-Mantra Evam Kanya Pujan Ka Sahi Vidhan",
            journal: "Rupayan Magazine, Amar Ujjala, Delhi",
            year: "2011",
            type: "Magazine Article",
            description: "Nine mantras of the nine forms of Devi and proper rituals for Kanya Pujan.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 13,
            title: "Putra Nahi To Kaun? Sraddh Ka Adhikari",
            journal: "Rupayan Magazine, Amar Ujjala, Delhi",
            year: "2010",
            type: "Magazine Article",
            description: "Discussion on eligibility for performing Shraddh rituals in absence of sons.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 14,
            title: "PitriPaksha Me Kya Karen Kya Naa Karen?",
            journal: "Rupayan Magazine, Amar Ujjala, Delhi",
            year: "2010",
            type: "Magazine Article",
            description: "Guidelines on dos and don'ts during Pitri Paksha.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 15,
            title: "Shakti Darshan",
            journal: "Rupayan Magazine, Amar Ujjala, Delhi",
            year: "2010",
            type: "Magazine Article",
            description: "Exploration of Shakti philosophy and worship.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 16,
            title: "Bhumi Shodhan Me Shalyodhar Prakriya",
            journal: "VastuVimarsh, Research Journal, Publication Division, S.L.S.R.S.V. New Delhi",
            year: "2011",
            type: "Research Article",
            description: "Process of defect removal in land purification according to Vastu.",
            category: "Vastu Shastra",
            status: "Published"
        },
        {
            id: 17,
            title: "Jyotish Shastra Ka Swaroop Evam Aadhunik Sandarbh Mein Upyogita",
            journal: "Research Today, Journal of The Society for Education & Social Welfare, Varanasi",
            year: "2023",
            type: "Research Article",
            description: "Nature of Jyotish Shastra and its utility in modern context.",
            category: "Jyotish",
            status: "Published"
        },
        {
            id: 18,
            title: "Mahakumbh Vimarsha",
            journal: "The Eternity, Erudite Publication, New Delhi",
            year: "2024",
            type: "Research Article",
            description: "Comprehensive discourse on Mahakumbh and its significance.",
            category: "Vedic Studies",
            status: "Published"
        },
        {
            id: 19,
            title: "Vedik Vangmay Mein Nakshatra Vigyan",
            journal: "Ayan, Research Journal, Lok Manav Samaj Kalyan Sansthan Aurangabad",
            year: "2024",
            type: "Research Article",
            description: "Study of constellation science in Vedic literature.",
            category: "Astronomy",
            status: "Published"
        }
    ];

    // Books Published (4 entries from ArticlesPage)
    const booksPublished = [
        {
            id: 1,
            title: "Ratnavigyanam: Jyotisham",
            publisher: "Bhartiya Vidya Prakashan, Delhi",
            year: "2011",
            isbn: "81-217-0263-8",
            description: "Comprehensive study of gemology in Jyotish and its practical applications.",
            category: "Jyotish"
        },
        {
            id: 2,
            title: "Dev Prasad Vastu Vidhanam : Temple Vastu",
            publisher: "Bhartiya Book Corporation, Delhi",
            year: "2010",
            isbn: "978-81-122-54-7",
            description: "Detailed guide on temple architecture according to Vastu principles and divine architectural norms.",
            category: "Vastu Shastra"
        },
        {
            id: 3,
            title: "Bhaishajya Jyotisham : Medical Astrology",
            publisher: "Bhartiya Vidya Prakashan, Delhi",
            year: "2010",
            isbn: "81-217-0262-1",
            description: "Comprehensive treatise on medical astrology principles and their therapeutic applications.",
            category: "Medical Astrology"
        },
        {
            id: 4,
            title: "Bharatiya Vastu Vidyake Vaigyanik Aadhar",
            publisher: "Manyata Prakashan, Delhi",
            year: "2004",
            isbn: "Not Available",
            description: "Scientific foundations of Indian Vastu science and its architectural principles.",
            category: "Vastu Shastra"
        }
    ];

    // Statistics (3 metrics: International Events, Years Active, Research Papers)
    const statistics = [
        { 
            value: "60+", 
            label: "National & International Events", 
            description: "Across India and Around the World" 
        },
        { 
            value: "29+", 
            label: "Years Active", 
            description: "Research & Teaching" 
        },
        { 
            value: "28+", 
            label: "Research Papers", 
            description: "Published Articles" 
        }
    ];

    // Research Areas (7 categories with color mappings)
    const categories = [
        { name: "Jyotish", color: "bg-primary-100 text-primary-700" },
        { name: "Medical Astrology", color: "bg-accent-100 text-accent-700" },
        { name: "Vastu Shastra", color: "bg-secondary-100 text-secondary-700" },
        { name: "Astronomy", color: "bg-blue-100 text-blue-700" },
        { name: "Sanskrit Studies", color: "bg-purple-100 text-purple-700" },
        { name: "Vedic Studies", color: "bg-green-100 text-green-700" },
        { name: "Calendar Studies", color: "bg-orange-100 text-orange-700" }
    ];

    return (
        <div className="min-h-screen bg-secondary-50">
            <HeroSection bgImage={banner} frontImage={profile}>
                <div className="text-left space-y-4 lg:space-y-6">
                    <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-heritage-ivory leading-tight">
                        Research & Academic Contributions
                    </h1>
                    
                    <h2 className="text-xl lg:text-2xl xl:text-3xl font-sans font-semibold text-heritage-gold">
                        Publications, Conferences & Scholarly Work
                    </h2>
                    
                    <p className="text-lg lg:text-xl text-heritage-ivory/95 font-serif leading-relaxed">
                        Comprehensive overview of research publications, books, and academic contributions 
                        spanning multiple disciplines including Jyotish, Vedic Studies, and Sanskrit scholarship.
                    </p>
                </div>
            </HeroSection>

            <div className="container mx-auto px-4 max-w-7xl py-16">
                {/* Statistics Section */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                    {statistics.map((stat, index) => (
                        <div 
                            key={index}
                            className="bg-white rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 p-6 text-center"
                        >
                            <div className="text-3xl font-bold text-primary-500 mb-2">
                                {stat.value}
                            </div>
                            <div className="text-lg font-semibold text-gray-800 mb-1">
                                {stat.label}
                            </div>
                            <div className="text-sm text-gray-600">
                                {stat.description}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Research Areas Section */}
                <section className="mb-16">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-6 text-center">
                        Research Areas & Expertise
                    </h2>
                    <div className="flex flex-wrap justify-center gap-4">
                        {categories.map((category, index) => (
                            <span 
                                key={index}
                                className={`px-4 py-2 rounded-full font-semibold text-sm ${category.color}`}
                            >
                                {category.name}
                            </span>
                        ))}
                    </div>
                </section>

                {/* Research Publications Section */}
                <section className="mb-16">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-8 text-center">
                        Research Publications & Articles
                    </h2>
                    <div className="grid md:grid-cols-2 gap-8">
                        {publications.map((publication) => (
                            <div 
                                key={publication.id}
                                className="bg-white rounded-2xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-[1.02]"
                            >
                                <div className="mb-4">
                                    <span className="bg-primary-100 text-primary-700 px-3 py-1 rounded-full text-sm font-semibold">
                                        {publication.category}
                                    </span>
                                </div>
                                
                                <h3 className="text-heading-md font-serif text-heritage-maroon mb-2 leading-tight">
                                    {publication.title}
                                </h3>
                                
                                <div className="text-primary-600 font-semibold mb-1 text-sm">
                                    {publication.journal}
                                </div>
                                
                                <div className="text-secondary-500 text-xs mb-3">
                                    {publication.type} • {publication.status}
                                </div>
                                
                                <p className="text-secondary-600 leading-relaxed text-sm">
                                    {publication.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Books Published Section */}
                <section className="mb-16">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-8 text-center">
                        Books Published
                    </h2>
                    <div className="grid md:grid-cols-2 gap-8">
                        {booksPublished.map((book) => (
                            <div 
                                key={book.id}
                                className="bg-white rounded-2xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-[1.02]"
                            >
                                <div className="flex justify-between items-start mb-4">
                                    <span className="bg-accent-100 text-accent-700 px-3 py-1 rounded-full text-sm font-semibold">
                                        {book.category}
                                    </span>
                                    <span className="text-secondary-500 text-sm">{book.year}</span>
                                </div>
                                
                                <h3 className="text-heading-md font-serif text-heritage-maroon mb-2 leading-tight">
                                    {book.title}
                                </h3>
                                
                                <div className="text-primary-600 font-semibold mb-1 text-sm">
                                    {book.publisher}
                                </div>
                                
                                <div className="text-secondary-500 text-xs mb-3">
                                    ISBN: {book.isbn}
                                </div>
                                
                                <p className="text-secondary-600 leading-relaxed text-sm">
                                    {book.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ResearchPage;
